import { IconConfig } from "../types";

export const houseTree:IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 66.824 51.148",
  elements: [
    {
      type: 'g',
      id: "house-tree_Groupe_2847",
      className: "Groupe 2847",
      transform: "translate(-0.001 0)",
      children: [
        {
          type: 'path',
          id: "house-tree_Tracé_2510",
          className: "Tracé 2510",
          d: "M100.31,10.368a1.521,1.521,0,0,0,1.259.171v1.733l-1.136.449a1.013,1.013,0,0,0,.746,1.883l8.275-3.276.063-.025,10.565-4.183a1.716,1.716,0,0,1,1.27,0l24.4,9.659a1.727,1.727,0,0,1,.97,2.24,1.013,1.013,0,1,0,1.883.746A3.756,3.756,0,0,0,146.5,14.9L122.1,5.238a3.741,3.741,0,0,0-2.762,0l-9.21,3.647V6.461l1.1-.529a1.542,1.542,0,0,0,.872-1.383V1.535A1.534,1.534,0,0,0,109.9.152l-9.439,4.521a1.542,1.542,0,0,0-.872,1.384V9.071A1.526,1.526,0,0,0,100.31,10.368Zm7.791-.682L103.6,11.47V9.59L108.1,7.431ZM101.62,6.367l8.456-4.051V4.239l-1.367.655a.686.686,0,0,0-.063.03l-6.492,3.11-.017.008-.516.247Zm0,0",
          transform: "translate(-86.142 0)"
        },
        {
          type: 'path',
          id: "house-tree_Tracé_2511",
          className: "Tracé 2511",
          d: "M213.876,289.176a1.013,1.013,0,0,0-1.013,1.013v1.183a1.013,1.013,0,0,0,2.026,0v-1.183A1.013,1.013,0,0,0,213.876,289.176Zm0,0",
          transform: "translate(-184.113 -250.12)"
        },
        {
          type: 'path',
          id: "house-tree_Tracé_2512",
          className: "Tracé 2512",
          d: "M280.6,235.488h10.617a1.634,1.634,0,0,0,1.583-1.677v-8.74a1.634,1.634,0,0,0-1.583-1.677H280.6a1.634,1.634,0,0,0-1.583,1.677v8.74A1.634,1.634,0,0,0,280.6,235.488Zm.443-5.034H284.9v3.008h-3.852Zm5.878,3.008v-3.008h3.852v3.008Zm3.852-5.034h-3.852V225.42h3.852ZM284.9,225.42v3.008h-3.852V225.42Zm0,0",
          transform: "translate(-241.335 -193.223)"
        },
        {
          type: 'path',
          id: "house-tree_Tracé_2513",
          className: "Tracé 2513",
          d: "M226.309,139.064a1.013,1.013,0,0,0-1.013-1.013h-8.962a1.013,1.013,0,0,0,0,2.026H225.3A1.013,1.013,0,0,0,226.309,139.064Zm0,0",
          transform: "translate(-186.239 -119.406)"
        },
        {
          type: 'path',
          id: "house-tree_Tracé_2514",
          className: "Tracé 2514",
          d: "M66.825,117.383H64.392v-2.058a5.429,5.429,0,0,0,3.029-1.441,5.485,5.485,0,0,0,.368-7.615.946.946,0,0,1-.179-.927,4.148,4.148,0,1,0-7.881.027.894.894,0,0,1-.174.884,5.487,5.487,0,0,0,2.811,8.966v2.165h-5.2V97.474a1.013,1.013,0,0,0-2.026,0v19.909H34.206v-16.7a2.259,2.259,0,0,0-2.256-2.256h-9.8a2.259,2.259,0,0,0-2.256,2.256v16.7H14.012V89.162L34.576,81.02,55.14,89.162v4.261a1.013,1.013,0,0,0,2.026,0V89.964l.427.169a3.736,3.736,0,0,0,1.38.264,1.013,1.013,0,1,0,0-2.026,1.72,1.72,0,0,1-.634-.122l-1.768-.7a.931.931,0,0,0-.092-.036l-21.53-8.524a1.011,1.011,0,0,0-.745,0L12.671,87.514c-.03.011-.06.022-.089.035l-1.769.7A1.726,1.726,0,1,1,9.542,85.04l1.6-.633a1.013,1.013,0,0,0-.746-1.883l-1.6.633a3.751,3.751,0,1,0,2.762,6.976l.428-.169v27.419H6.215v-2.058a5.429,5.429,0,0,0,3.029-1.441,5.485,5.485,0,0,0,.368-7.615.946.946,0,0,1-.179-.927,4.148,4.148,0,1,0-7.881.027.894.894,0,0,1-.174.884,5.487,5.487,0,0,0,2.811,8.966v2.165H2.327a1.013,1.013,0,1,0,0,2.026h64.5a1.013,1.013,0,0,0,0-2.026ZM60.211,110.1a3.442,3.442,0,0,1,.861-2.509,2.937,2.937,0,0,0,.579-2.867,2.121,2.121,0,0,1,2.014-2.788l.115,0a2.122,2.122,0,0,1,1.9,2.772,2.954,2.954,0,0,0,.584,2.891,3.463,3.463,0,0,1-1.875,5.665v-2.017a1.013,1.013,0,1,0-2.026,0v1.835A3.508,3.508,0,0,1,60.211,110.1Zm-58.177,0a3.442,3.442,0,0,1,.861-2.509,2.937,2.937,0,0,0,.579-2.867,2.122,2.122,0,0,1,2.014-2.788l.115,0a2.122,2.122,0,0,1,1.9,2.772,2.954,2.954,0,0,0,.583,2.891,3.461,3.461,0,0,1-1.875,5.665v-2.017a1.013,1.013,0,1,0-2.026,0v1.835A3.507,3.507,0,0,1,2.034,110.1Zm19.89-9.416a.231.231,0,0,1,.231-.231h9.8a.231.231,0,0,1,.231.231v16.7H21.924Zm0,0",
          transform: "translate(0 -68.259)"
        }
      ]
    }
  ]
}
